<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-container v-if="this.condition()" fluid >
      <a class="anchor" id="blocetab"></a>

    <v-row dense>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title>
            Etablissement
            <SimpleChips
                icon="mdi-alpha-e-circle-outline"
                v-bind:value="
            administratif_donnes.etatAdministratifEtablissement.valeur
          "
            ></SimpleChips>
          </v-card-title>

          <v-simple-table>
            <tbody>
             <tr>
                <td>Situation</td>
                <td>{{
                    this.situation
                  }}
                </td>
              </tr>
              <SimpleTr
                v-bind:var="administratif_donnes"
                data="dateCreationEtablissement"
                field="libelle"
                prefix="Créé le: "
            ></SimpleTr>
            <SimpleTr
                v-bind:var="identite"
                data="siret"
                field="valeur"
                prefix="Siret : "
            ></SimpleTr>

            <SimpleTr
                v-bind:var="administratif_donnes"
                data="activitePrincipaleEtablissement"
                field="mix"
                prefix="Activité : "
            ></SimpleTr>

            <SimpleTr
                v-bind:var="administratif_indicateur"
                :suffix="' ('+administratif_indicateur.anneeEffectifsEtablissement.valeur+', source: INSEE)'"
                data="trancheEffectifsEtablissement"
                field="libelle"
                prefix="Effectifs : "
            ></SimpleTr>

             <SimpleTr
                v-bind:value="ccn_calcule"
                prefix="CCN Calculée : "
            ></SimpleTr>
             <tr v-if="ccn_declare!=null">
                <td>CNN déclarée :</td>
                <td v-if="ccn_declare.length==1">

                  {{
                    ccn_declare[0]["lib"]
                  }}
                </td>
                <td v-if="ccn_declare.length>1">
                    <ul >
                    <li v-for="item in ccn_declare" :key="item.ccn">
                     {{ item.lib }} ({{item.ccn }})
                    </li>
                  </ul>

                </td>
              </tr>

            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimpleTr from "@/components/layout/SimpleTr.vue";
import SimpleChips from "@/components/layout/SimpleChips.vue";

export default {
  name: "Administratif",
  props: ["etablissement"],
  components: {
    SimpleTr,
    SimpleChips,
  },
  computed: {
    administratif_donnes: function () {
      return this.$store.getters.getbloc("administratif", "donnees")
    },
    situation: function () {
      try {
        var donnees = this.$store.getters.getbloc("administratif", "donnees")
        if (donnees != undefined && donnees.etatAdministratifEtablissement != undefined && donnees.etatAdministratifEtablissement.valeur == "F") {
          return "Fermé le " + donnees.dateDebutPeriodeEtablissement.libelle
        } else {
          return "Actif"
        }
      }
      catch (e) {
        console.log(e)
        return "Etat inconnu"
      }
    },
    administratif_indicateur: function () {
      return this.$store.getters.getbloc("administratif", "indicateurs")
    },
    administratif_calule: function () {
      return this.$store.getters.getbloc("administratif", "indicateurs")
    },
    ccn_calcule: function () {
      var ccn = this.$store.getters.getbloc("administratif", "indicateurs", "ccn_etab", null, "valeur")
      if ( ccn==null || !ccn["ccn_libelle"]) {
        return null
      } else {
        return ccn["ccn_libelle"]+" ("+ccn["ccn_proba"]+")"
      }
    },
    ccn_declare: function () {
      var ccn = this.$store.getters.getbloc("administratif", "indicateurs", "ccn_etab", null, "valeur")
      if (ccn==null || ccn["ccn_declare"]==null) {
        return null
      } else {
        return ccn["ccn_declare"]
      }
    },
    identite: function () {
      return this.$store.getters.getbloc("identite", "donnees")
    },
  },
  methods: {
    condition() {
        return this.$store.getters.condition("administratif", "donnees") &&   this.$store.getters.condition("identite", "donnees")
    },
  },
};
</script>
